export default __webpack_public_path__ + "static/media/washupVoucher1.e17a6b8f.png";